import { AppBar, Box, Button, Toolbar, Typography } from "@bvhi/ui-base";
import { useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { useAuthContext } from "../context/use-auth-context";
import { useAuthentication } from "../hooks/use-authentication";
import { UserAvatar } from "./user-avatar";

// TODO Add tests logout and logo click
export const BVHIAppBar = () => {
  const { t } = useTranslation(["common"]);
  const { login } = useAuthentication();
  const { currentUser } = useAuthContext();
  const navigate = useNavigate();

  return (
    <AppBar position="sticky" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
      <Toolbar>
        <img
          alt="logo"
          onClick={() => void navigate({ to: "/" })}
          src="/hiDataSyncLogoWhite.svg"
          style={{ height: 32, userSelect: "none", cursor: "pointer" }}
        />

        <Box sx={{ flexGrow: 1 }} />
        {!currentUser && (
          <Button color="inherit" onClick={login} variant="text">
            {t("common:button.login")}
          </Button>
        )}
        {!currentUser && (
          <Button color="inherit" onClick={() => void navigate({ to: "/registration" })} variant="text">
            {t("common:button.register")}
          </Button>
        )}
        {currentUser && (
          <Box sx={{ alignItems: "center", display: "flex", flexShrink: 0, gap: 1.5, minWidth: 0 }}>
            <Typography
              component="span"
              data-testid="app-bar-support-id"
              data-user-support-id={currentUser.supportId?.trim() || ""}
              noWrap
              sx={{ color: "inherit", opacity: 0.95 }}
              variant="body2"
            >
              {t("common:header.support.id", {
                supportId: currentUser.supportId?.trim() || t("common:header.support.id.not.present"),
              })}
            </Typography>
            <UserAvatar />
          </Box>
        )}
      </Toolbar>
    </AppBar>
  );
};
